import { Center, Spinner } from '@efishery/onefish';

export const Loading = () => {
  return (
    <Center>
      <Spinner color="brand.500" size="lg" speed="0.65s" />
    </Center>
  );
};
